import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import LoggedOutLayout from './layouts/LoggedOut'
import LoggedInLayout from './layouts/LoggedIn'
import Login from './routes/Login'
import SignUp from './routes/SignUp'
import Room from './routes/Room'
import Contacts from './routes/Contacts'
import News from './routes/News'
import ListName from './routes/Contacts/ListName'
import Settings from './routes/Settings'
import ManagePlans from './routes/ManagePlans'
import Billing from './routes/Billing'
import ResetPassword from './routes/ResetPassword'
import FaQs from './routes/FaQs'
import Registration from './routes/Registration'
import Domain from './routes/Domain'
import DomainCreate from './routes/Domain/create'
import DomainLayout from './layouts/Domain'

// All the routes of our app
class Routes extends Component {

  render () {
    let domainRoute = `/domain`
    return (
      <Router>
        <Switch>
          {/* Routes and the layouts for a logged out user */}

          <News path="/edit_news" exact/>
          <DomainCreate path={`${domainRoute}/create`} exact/>
          <DomainCreate path={`${domainRoute}/:id`} exact/>
          <DomainLayout path={`${domainRoute}`} component={Domain}/>

          <LoggedInLayout path="/" exact component={Room}/>
          <LoggedInLayout path="/settings" component={Settings}/>
          <LoggedInLayout path="/admin" exact component={Room}/>
          <LoggedInLayout path="/admin/contacts" component={Contacts}/>
          <LoggedInLayout path="/admin/news" component={News}/>
          <LoggedInLayout
            path="/admin/contact-list/:name"
            component={ListName}
          />
          <LoggedInLayout path="/admin/settings" exact component={Settings}/>
          <LoggedInLayout
            path="/admin/settings/manage-plans"
            exact
            component={ManagePlans}
          />
          <LoggedInLayout
            path="/admin/settings/billing"
            exact
            component={Billing}
          />
          <LoggedInLayout
            path="/admin/settings/manage-plans/FaQ"
            component={FaQs}
          />
          <LoggedOutLayout path="/login" component={Login}/>
          <LoggedOutLayout exact path="/forgot-password" component={Login}/>
          <LoggedOutLayout path="/signup" component={SignUp}/>
          <LoggedOutLayout path="/password" component={ResetPassword}/>
          <LoggedOutLayout path="/change_email" component={ResetPassword}/>
          <LoggedOutLayout path="/activate" component={ResetPassword}/>
          <Route path="/registration/:id" component={Registration}/>
          <Route component={NoMatch}/>
        </Switch>
      </Router>
    )
  }
}

const NoMatch = ({location}) => {
  window.setTimeout('window.location=(\'/\');', 3000)
  return (
    <section className="flex items-center flex-column justify-center h-100 bg-washed-blue">
      <header class="tc ph5 lh-copy">
        <h1 className="f1 f-headline-l w-100 tc code mb3 fw9 dib tracked-tight light-purple">
          404
        </h1>
        <h2 className="tc f1-l fw1">
          指定されたページはみつかりません。３秒後にトップへ戻ります。 <code>{location.pathname}</code>
        </h2>
      </header>
    </section>
  )
}

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.js